import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllHolidays = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/holidays',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveHoliday = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/holidays',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateHoliday = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/holidays/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteHoliday = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/holidays/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllHolidays,
  saveHoliday,
  deleteHoliday,
  updateHoliday,
}
